import { PointCardEditPage } from './pointCard.edit.page';

export default PointCardEditPage;
